(function () {
  'use strict';

  var instances = {};

  function instanceKey(sectionId, tabId) {
    return sectionId + ':' + tabId;
  }

  function parseConfig(root) {
    try {
      return JSON.parse(root.getAttribute('data-tcc-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function makeAutoplay(settings) {
    if (!settings || !settings.autoplay || prefersReducedMotion()) return false;
    return {
      delay: settings.autoplayDelay || 5000,
      disableOnInteraction: true
    };
  }

  function buildSwiperOpts(cfg, swEl) {
    var dt = cfg.desktop || {};
    var mb = cfg.mobile || {};
    var slideCount = swEl.querySelectorAll('.swiper-slide').length;

    var slidesDt = parseFloat(dt.slidesPerView) || 4;
    var slidesMb = parseFloat(mb.slidesPerView) || 1.2;
    var maxSlides = Math.max(slidesDt, slidesMb);
    var canLoop = (dt.loop || mb.loop) && slideCount > 1 && slideCount >= Math.ceil(maxSlides) * 2;

    return {
      slidesPerView: slidesMb,
      spaceBetween: parseInt(mb.spaceBetween, 10) || 0,
      loop: canLoop,
      speed: parseInt(mb.speed, 10) || 400,
      autoplay: makeAutoplay(mb),
      grabCursor: mb.draggable !== false,
      allowTouchMove: mb.draggable !== false,
      centeredSlides: !!mb.centeredSlides,
      watchOverflow: true,
      resistanceRatio: 0.65,
      breakpoints: {
        768: {
          slidesPerView: slidesDt,
          spaceBetween: parseInt(dt.spaceBetween, 10) || 0,
          speed: parseInt(dt.speed, 10) || 400,
          autoplay: makeAutoplay(dt),
          grabCursor: dt.draggable !== false,
          allowTouchMove: dt.draggable !== false,
          centeredSlides: !!dt.centeredSlides
        }
      }
    };
  }

  function destroySwiper(swEl) {
    if (swEl && swEl.swiper && !swEl.swiper.destroyed) {
      swEl.swiper.destroy(true, true);
    }
  }

  function destroySection(root) {
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');

    root.querySelectorAll('[data-tab-swiper]').forEach(function (swEl) {
      var panel = swEl.closest('[data-tab-panel]');
      var tabId = panel ? panel.getAttribute('data-tab-id') : null;
      destroySwiper(swEl);
      if (tabId) delete instances[instanceKey(sectionId, tabId)];
    });

    if (root._tccClickHandler) {
      root.removeEventListener('click', root._tccClickHandler);
      delete root._tccClickHandler;
      delete root._tccBound;
    }
  }

  function initSwiperForPanel(root, tabId) {
    var sectionId = root.getAttribute('data-section-id');
    var key = instanceKey(sectionId, tabId);
    var swEl = document.getElementById('tcc-swp-' + tabId);

    if (!swEl) return null;

    if (instances[key] && !instances[key].destroyed) {
      instances[key].update();
      instances[key].updateSize();
      return instances[key];
    }

    if (typeof Swiper === 'undefined') return null;

    var cfg = parseConfig(root);
    var opts = buildSwiperOpts(cfg, swEl);
    var swiper = new Swiper(swEl, opts);
    instances[key] = swiper;
    return swiper;
  }

  function activateTab(root, tabId) {
    if (!tabId) return;

    var tabs = root.querySelectorAll('.tcc__tab');
    var panels = root.querySelectorAll('[data-tab-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-tab-target') === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-tab-id') === tabId;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            initSwiperForPanel(root, tabId);
          });
        });
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initSection(root, attempt) {
    if (!root) return;

    if (typeof Swiper === 'undefined') {
      if ((attempt || 0) < 60) {
        setTimeout(function () {
          initSection(root, (attempt || 0) + 1);
        }, 50);
      }
      return;
    }

    destroySection(root);

    var clickHandler = function (e) {
      var tab = e.target.closest('.tcc__tab');
      if (!tab || !root.contains(tab)) return;
      e.preventDefault();
      var tabId = tab.getAttribute('data-tab-target');
      if (tabId) activateTab(root, tabId);
    };

    root.addEventListener('click', clickHandler);
    root._tccBound = true;
    root._tccClickHandler = clickHandler;

    var activeTab = root.querySelector('.tcc__tab.is-active') || root.querySelector('.tcc__tab');
    if (activeTab) {
      if (!activeTab.classList.contains('is-active')) {
        activeTab.classList.add('is-active');
      }
      activateTab(root, activeTab.getAttribute('data-tab-target'));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="tabs-cards-carousel"]').forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="tabs-cards-carousel"]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="tabs-cards-carousel"]');
    if (root) destroySection(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!e.detail || !e.detail.blockId) return;

    var blockEl = document.getElementById('shopify-block-' + e.detail.blockId);
    if (!blockEl) return;

    var root = blockEl.closest('[data-section-type="tabs-cards-carousel"]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');
    var panel = blockEl.closest('[data-tab-panel]');

    if (panel) {
      var tabId = panel.getAttribute('data-tab-id');
      activateTab(root, tabId);

      requestAnimationFrame(function () {
        var swiper = instances[instanceKey(sectionId, tabId)];
        if (!swiper) {
          swiper = initSwiperForPanel(root, tabId);
        }
        if (!swiper) return;
        var slide = blockEl.closest('.swiper-slide');
        if (!slide) return;
        var index = Array.prototype.indexOf.call(swiper.slides, slide);
        if (index >= 0) swiper.slideTo(index);
      });
      return;
    }

    var tabBtn = root.querySelector('[data-tab-target="' + e.detail.blockId + '"]');
    if (tabBtn) {
      activateTab(root, e.detail.blockId);
    }
  });
})();
